const PERFORMANCE_SO_LOAD_TIME = 'ME_performance_so_load_time';
const PERFORMANCE_JO_LOAD_TIME = 'ME_performance_jo_load_time';

const PAGE_VIEW = 'ME_pageview';
const FILTER = 'ME_filter';

// HandledBy measure events
const HANDLEDBY_OPEN_ASSIGN_AGENT_MODAL = 'ME_handledby_open_assign_agent_modal';
const HANDLEDBY_SAVE_ASSIGN_AGENT_MODAL = 'ME_handledby_save_assign_agent_modal';
const HANDLEDBY_CANCEL_ASSIGN_AGENT_MODAL = 'ME_handledby_cancel_assign_agent_modal';

// ChangeCost measure events
const CHANGE_COST_OPEN_MODAL = 'ME_change_cost_open_modal';
const CHANGE_COST_CLOSE_MODAL = 'ME_change_cost_close_modal';
const CHANGE_COST_QUOTE = 'ME_change_cost_quote';
const CHANGE_COST_SAVE = 'ME_change_cost_save';

// Loading Times measure events
// Journeys
const JOURNEYS_LOAD = 'ME_journeys_load';
const JOURNEY_MODAL_OPEN = 'ME_journey_modal_open';

const JOURNEY_SIDEBAR_TAB = 'ME_journey_sidebar_tab_change';

const OPEN_CONVERSATION = 'ME_open_conversation';
const CREATE_CONVERSATION = 'ME_create_conversation';

// Shipperorders
const SHIPPERORDERS_LOAD = 'ME_shipperorders_load';
const SHIPPERORDER_MODAL_OPEN = 'ME_shipperorders_modal_open';

const GO_NEXT = 'ME_go_to_next';
const GO_PREVIOUS = 'ME_go_to_previous';

const JOURNEY_MAP_OPEN = 'ME_journey_map_open';
const JOURNEY_MAP_OPEN_DRIVER_INFO = 'ME_journey_map_open_driver_info';
const JOURNEY_MAP_GOOGLE_MAPS_CLICK = 'ME_journey_map_google_maps_click';

const CREATE_LOG_START = 'ME_create_log_start';
const CREATE_LOG_END = 'ME_create_log_end';
const CREATE_MANUAL_LOG = 'ME_create_manual_log';
const EDIT_LOG_START = 'ME_edit_log_start';
const EDIT_LOG_END = 'ME_edit_log_end';
const TOGGLE_LOGS_VISIBLE = 'ME_TOGGLE_LOGS_VISIBLE';

const COPY_DETAIL = 'ME_copy_order_detail';
const ADVANCE_JOURNEY_STATUS = 'ME_advance_journey_status';
const VIEW_VALID_VEHICLES = 'ME_view_valid_vehicles';

const LAUNCH_JOURNEY = 'ME_launch_journey';

const MANUAL_ROUTE_CREATION = 'ME_manual_route_creation';

const GET_ETA_ON_DEMAND = 'ME_get_eta_on_demand';

const VIEW_DRIVER_DAY = 'ME_view_driver_day';

// Shipper order handling measurements
const SHIPPER_ORDER_UPDATE_START = 'ME_shipperorder_update_start';
const SHIPPER_ORDER_UPDATE_END = 'ME_shipperorder_update_end';

const JOURNEY_UPDATE_START = 'ME_journey_update_start';
const JOURNEY_UPDATE_END = 'ME_journey_update_end';

const JOB_REALTIME_UPDATE = 'ME_job_realtime_update';
const QUEUED_REALTIME_UPDATE = 'ME_queued_realtime_update';

const MANUAL_ROUTE_CREATION_TIME = 'ME_manual_route_creation_time';

// Assignment
const ASSIGNMENT_LAUNCH_CLICK = 'ME_assignment_launch_click';
const ASSIGNMENT_ASSIGN_DRIVER_CLICK = 'ME_assignment_assign_driver_click';
const ASSIGNMENT_EXTRA_COST_CLICK = 'ME_assignment_extra_cost_click';
const ASSIGNMENT_MOVE_TO_QUEUED_CLICK = 'ME_assignment_move_to_queued_click';
const ASSIGNMENT_DISTANCE_CLICK = 'ME_assignment_distance_click';
const ASSIGNMENT_MY_FLEET_LOAD = 'ME_assignment_my_fleet_load';

// Tasks
const ME_TASKS_OPEN_DETAIL = 'ME_tasks_open_detail';
const REVIEW_TASK = 'ME_review_task';

// Chat
const CHAT_CONVERSATION_OPEN = 'ME_chat_conversation_open';
const CHAT_CONVERSATION_CREATE = 'ME_chat_conversation_create';
const CHAT_CONVERSATION_MESSAGES_LOADED = 'ME_chat_conversation_loaded';
const CHAT_CONVERSATION_SEND = 'ME_chat_conversation_send';

export {
  PERFORMANCE_SO_LOAD_TIME,
  PERFORMANCE_JO_LOAD_TIME,
  HANDLEDBY_OPEN_ASSIGN_AGENT_MODAL,
  HANDLEDBY_SAVE_ASSIGN_AGENT_MODAL,
  HANDLEDBY_CANCEL_ASSIGN_AGENT_MODAL,
  PAGE_VIEW,
  FILTER,
  GO_NEXT,
  GO_PREVIOUS,
  CHANGE_COST_OPEN_MODAL,
  CHANGE_COST_CLOSE_MODAL,
  CHANGE_COST_QUOTE,
  CHANGE_COST_SAVE,
  JOURNEY_MAP_OPEN,
  JOURNEY_MAP_OPEN_DRIVER_INFO,
  JOURNEY_MAP_GOOGLE_MAPS_CLICK,
  JOURNEYS_LOAD,
  JOURNEY_MODAL_OPEN,
  SHIPPERORDERS_LOAD,
  SHIPPERORDER_MODAL_OPEN,
  COPY_DETAIL,
  ADVANCE_JOURNEY_STATUS,
  VIEW_VALID_VEHICLES,
  LAUNCH_JOURNEY,
  MANUAL_ROUTE_CREATION,
  GET_ETA_ON_DEMAND,
  SHIPPER_ORDER_UPDATE_START,
  SHIPPER_ORDER_UPDATE_END,
  JOURNEY_UPDATE_START,
  JOURNEY_UPDATE_END,
  JOB_REALTIME_UPDATE,
  QUEUED_REALTIME_UPDATE,
  CREATE_LOG_START,
  CREATE_LOG_END,
  CREATE_MANUAL_LOG,
  EDIT_LOG_START,
  EDIT_LOG_END,
  TOGGLE_LOGS_VISIBLE,
  MANUAL_ROUTE_CREATION_TIME,
  JOURNEY_SIDEBAR_TAB,
  ASSIGNMENT_LAUNCH_CLICK,
  ASSIGNMENT_ASSIGN_DRIVER_CLICK,
  ME_TASKS_OPEN_DETAIL,
  ASSIGNMENT_EXTRA_COST_CLICK,
  ASSIGNMENT_MOVE_TO_QUEUED_CLICK,
  ASSIGNMENT_DISTANCE_CLICK,
  ASSIGNMENT_MY_FLEET_LOAD,
  VIEW_DRIVER_DAY,
  REVIEW_TASK,
  OPEN_CONVERSATION,
  CREATE_CONVERSATION,
  CHAT_CONVERSATION_OPEN,
  CHAT_CONVERSATION_CREATE,
  CHAT_CONVERSATION_MESSAGES_LOADED,
  CHAT_CONVERSATION_SEND,
};
